"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var StopFill = {
  name: 'stop',
  theme: 'fill',
  nameWithTheme: 'stop-fill',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z'
    },
    children: []
  }]
};
exports.default = StopFill;